import { jsxs as D, jsx as e } from "react/jsx-runtime";
import O from "react";
import { c } from "./index.CWkFp9WS.js";
import { O as p } from "./ODSLogo.dM3TU2ay.js";
import { u as b, a as m, H as N } from "./ODSGlobalHeader.utils.CBEpEpr3.js";
import { u as v } from "./viewport-size.DKLty78u.js";
import '../assets/ODSGlobalHeader.css';const $ = (l) => {
  const {
    children: d,
    className: n,
    applicationName: r,
    variant: a = "standard",
    logoProps: o,
    ...t
  } = l, [s, S] = O.useState(!1), u = v(), H = m();
  return O.useEffect(() => {
    H > 0 ? S(!0) : S(!1);
  }, [H]), /* @__PURE__ */ e(
    N.Provider,
    {
      value: {
        variant: a,
        applicationName: r,
        scrolled: s,
        viewport: u
      },
      children: /* @__PURE__ */ e(
        "header",
        {
          role: "banner",
          className: c("ODSGlobalHeader", n, {
            [`ODSGlobalHeader--${a}`]: !0,
            "ODSGlobalHeader--scrolled": s
          }),
          "data-variant": a,
          "data-scrolled": s,
          "data-viewport": u,
          ...t,
          children: /* @__PURE__ */ e("div", { className: "ODSGlobalHeader-FixedWrapper", children: /* @__PURE__ */ D("div", { className: "ODSGlobalHeader-Container", children: [
            /* @__PURE__ */ e(
              "div",
              {
                className: c("ODSGlobalHeader-Logo", {
                  [`ODSGlobalHeader-Logo--${a}`]: !0,
                  "ODSGlobalHeader-Logo--scrolled": s
                }),
                children: /* @__PURE__ */ e(
                  p,
                  {
                    "aria-label": "ODS Global Header Logo",
                    type: "primary",
                    ...o
                  }
                )
              }
            ),
            r && /* @__PURE__ */ e(
              "div",
              {
                className: c("ODSGlobalHeader-ApplicationName", {
                  [`ODSGlobalHeader-ApplicationName--${a}`]: !0,
                  "ODSGlobalHeader-ApplicationName--scrolled": s
                }),
                "data-variant": a,
                children: /* @__PURE__ */ e("span", { className: "ODSGlobalHeader-ApplicationNameLabel", children: r })
              }
            ),
            /* @__PURE__ */ e(
              "div",
              {
                className: c("ODSGlobalHeader-Body", {
                  [`ODSGlobalHeader-Body--${a}`]: !0,
                  "ODSGlobalHeader-Body--scrolled": s
                }),
                "data-variant": a,
                children: d
              }
            )
          ] }) })
        }
      )
    }
  );
}, x = i("ODSGlobalHeaderMainNav"), w = i("ODSGlobalHeaderMainMenu"), P = i("ODSGlobalHeaderIconMenu"), A = G, B = i("ODSGlobalHeaderExternalMenu"), C = i("ODSGlobalHeaderMetaMenu"), E = (l) => {
  const { className: d, children: n, ...r } = l, { variant: a, scrolled: o } = b();
  return /* @__PURE__ */ e(
    "div",
    {
      className: c("ODSGlobalHeaderLangSwitcherMenu", d, {
        [`ODSGlobalHeaderLangSwitcherMenu--${a}`]: !0,
        "ODSGlobalHeaderLangSwitcherMenu--scrolled": o
      }),
      "data-variant": a,
      "data-scrolled": o,
      "aria-orientation": "horizontal",
      ...r,
      children: n
    }
  );
};
function i(l) {
  const d = (n) => {
    const { className: r, children: a, ...o } = n, { variant: t, scrolled: s } = b();
    return t === "subtle" && l === "ODSGlobalHeaderMainMenu" ? null : /* @__PURE__ */ e(
      "div",
      {
        className: c(l, r, {
          [`${l}--${t}`]: !0,
          [`${l}--scrolled`]: s
        }),
        "data-variant": t,
        "data-scrolled": s,
        ...o,
        children: a
      }
    );
  };
  return d.displayName = l, d;
}
function G(l) {
  const { className: d, children: n, ...r } = l, { variant: a, scrolled: o, applicationName: t } = b();
  return a === "slim" ? null : /* @__PURE__ */ D(
    "div",
    {
      className: c("ODSGlobalHeaderSecondaryNav", d, {
        [`ODSGlobalHeaderSecondaryNav--${a}`]: !0,
        "ODSGlobalHeaderSecondaryNav--scrolled": o
      }),
      "data-variant": a,
      "data-scrolled": o,
      ...r,
      children: [
        t && /* @__PURE__ */ e("span", { className: "ODSGlobalHeader-ApplicationNameLabel", children: t }),
        /* @__PURE__ */ e("div", { className: "ODSGlobalHeaderSecondaryNav-Body", children: n })
      ]
    }
  );
}
G.displayName = "ODSGlobalHeaderSecondaryNav";
export {
  $ as O,
  x as a,
  w as b,
  P as c,
  A as d,
  B as e,
  C as f,
  E as g
};
//# sourceMappingURL=ODSGlobalHeader.3SI5uG6R.js.map
